import {cn} from '@sollapay/ui';

import type {FC, ReactNode} from 'react';

export interface TrustAccountViewHeaderActionsProps {
  button?: ReactNode;
  balance: ReactNode;
  isBalanceHidden?: boolean;
}

/** The header's actions column — the account's button above its balance — shared with the skeleton. */
export const TrustAccountViewHeaderActions: FC<TrustAccountViewHeaderActionsProps> = ({
  button,
  balance,
  isBalanceHidden = false
}) => (
  <div data-slot="trust-account-header-actions" className="flex w-fit min-w-70 flex-col">
    {button && <div className="flex justify-end">{button}</div>}
    <div
      data-slot="header-balance"
      inert={isBalanceHidden}
      className={cn(
        'transition-all duration-300 ease-in-out empty:hidden',
        // Clip only while collapsed, so the card's hover and open ring isn't cut off.
        isBalanceHidden ? 'max-h-0 overflow-hidden opacity-0' : 'max-h-40 opacity-100',
        button && !isBalanceHidden && 'mt-3'
      )}
    >
      {balance}
    </div>
  </div>
);
